export function validChannelInPath(channel: string): boolean {
  if (typeof window === "undefined") return false;
  const path = window.location.pathname;
  return new RegExp(`^/${channel}(\/.*)?$`).test(path);
}
